export default "__VITE_ASSET__9oYpf018__"